// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.typeWrapper__PvklO {
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 5px;
  background-color: var(--tables-title-surface);
  border-radius: 5px;
}

.typeIcon__dB3xC {
  width: 34px;
  height: 34px;
}

.typeName__TYM4N {
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  color: var(--tables-secondary-row-sub-title-text);
  text-transform: uppercase;
}

.partNumberInfo__TE1O0 {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--tables-secondary-row-sub-title-text);
  text-transform: uppercase;
  white-space: nowrap;
  display: inline-block;
  margin-top: 12px;
}
@media print {
  .partNumberInfo__TE1O0 {
    overflow: hidden;
    height: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorDetails/components/SensorType/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAzEF;AA2EE;EAVF;IAWI,gBAAA;IACA,SAAA;EAxEF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.typeWrapper {\n  height: 120px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  row-gap: 5px;\n  background-color: var(--tables-title-surface);\n  border-radius: 5px;\n}\n\n.typeIcon {\n  width: 34px;\n  height: 34px;\n}\n\n.typeName {\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 14px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-transform: uppercase;\n}\n\n.partNumberInfo {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-transform: uppercase;\n  white-space: nowrap;\n  display: inline-block;\n  margin-top: 12px;\n\n  @media print {\n    overflow: hidden;\n    height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"typeWrapper": `typeWrapper__PvklO`,
	"typeIcon": `typeIcon__dB3xC`,
	"typeName": `typeName__TYM4N`,
	"partNumberInfo": `partNumberInfo__TE1O0`
};
module.exports = ___CSS_LOADER_EXPORT___;
